/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { EOrderState } from "../../model/order/orderState";
import { TOrderState } from "./model";

export function isOrderStateModel(obj: any, _argumentName?: string): obj is TOrderState {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.orderId === "number" &&
        (obj.orderState === EOrderState.Unknown ||
            obj.orderState === EOrderState.Initialized ||
            obj.orderState === EOrderState.Complete ||
            obj.orderState === EOrderState.Failed)
    )
}
